import {delay, map} from 'rxjs/operators';
import {of, Observable} from 'rxjs';
import {AuthorizationService} from '../../authorization/authorization.service';
import {ImmutableListRepositoryService} from '../../../lib/gelios-field/immutable-list-repository.service';
import {FilterMenuPopoverOption} from '../filter-menu-popover/filter-menu-popover.component';

export class UnitHelper {
  static getUnitIconClass(unitTypeName: string): string {
    if (!unitTypeName || !String(unitTypeName).trim()) {
      return 'icon';
    }
    return `icon icon-unit-type-${unitTypeName}`;
  }

  static getDashboardFilterUnitTypeConfig(authorizationService: AuthorizationService, immutableList: ImmutableListRepositoryService) {
    const sortOrder = [
      {key: 'showAll', visible: of(true)}
    ];
    const items = {
      showAll: {iconClass: 'icon icon-unit-type-all', label: 'All'}
    };

    const unitTypeList = immutableList.getListInstant('unit-type') || [];

    unitTypeList.forEach(unitTypeItem => {
      const key = unitTypeItem['unit_type_name'];
      if (!key) {
        return;
      }

      const visibility = authorizationService.unitTypeMenuVisibility(key);
      sortOrder.push({
        key: key,
        visible: visibility.pipe(delay(0))
      });
      items[key] = {
        iconClass: UnitHelper.getUnitIconClass(key),
        label: unitTypeItem.name
      };
    });

    return {
      label: 'Unit type',
      sortOrder: sortOrder,
      items: items
    };
  }

  static buildUnitTypeOptions(
    authorizationService: AuthorizationService,
    immutableList: ImmutableListRepositoryService,
    keySelector: 'id' | 'unit_type_name'
  ): Observable<FilterMenuPopoverOption[]> {
    return immutableList.getList('unit-type').pipe(
      map(unitTypes => {
        const options: FilterMenuPopoverOption[] = [
          {key: 'showAll', visible: of(true), label: 'All', iconClass: 'icon icon-unit-type-all'}
        ];
        unitTypes.forEach(unitType => {
          const unitTypeName = unitType['unit_type_name'];
          if (!unitTypeName) {
            return;
          }
          const visibility = authorizationService.unitTypeMenuVisibility(unitTypeName);
          options.push({
            key: unitType[keySelector],
            visible: visibility.pipe(delay(0)),
            label: unitType.name,
            iconClass: UnitHelper.getUnitIconClass(unitTypeName)
          });
        });
        return options;
      })
    );
  }
}
